import './index.css';
import 'react-toastify/dist/ReactToastify.min.css';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import config from './config';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: config.sentry.dsn,
  environment: config.appEnv || 'development',
  enabled: config.appEnv !== 'development',
  // integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  // tracesSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
